export const SOCKET_IO_CLIENT_BASE_OPTIONS = {
  transports: ['websocket'],
  secure: true,
  withCredentials: true,
  reconnection: true,
  reconnectionAttempts: Infinity,
  reconnectionDelay: 1000,
  reconnectionDelayMax: 10_000,
  timeout: 25_000,
};
